module.exports = __webpack_public_path__ + "static/media/HelpText.df671239.yml";